export default (numero) => (numero && parseFloat(numero) ? numero.toFixed(2).replace('.', ',') : '0,00');
